<template>
  <b-modal ref="reportissuemodal" centered :lazy="true" title="Report Issue" @shown="loadReportIssueData" :hide-header-close="true">
    <div class="loading-wrapper" v-if="isLoading">
      <spinner size="medium" message="Loading..."></spinner>
    </div>
    <b-form v-else  class="report-issue-modal">
      <b-form-group id="exampleInputGroup1" label="Send From" label-for="email">
        <b-form-input id="email" type="text" v-model="form.email" required placeholder="Enter your email">
        </b-form-input>
      </b-form-group>
      <b-form-group label="Comments">
        <b-form-textarea id="textarea1" v-model="form.comment" placeholder="" :rows="3" :max-rows="6">
        </b-form-textarea>
      </b-form-group>
      <b-form-group label="Report Content">
        <b-form-textarea id="textarea1" v-model="form.report" placeholder="" :rows="3" :max-rows="6">
        </b-form-textarea>
      </b-form-group>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <div class="text-right">
        <b-btn variant="flat" @click="closeModal()">
          Cancel
        </b-btn>
        <b-btn variant="primary" @click="sendReportIssue()">
          Send Issue Report
          <spinner size="small" v-if="buttonLoaders.send"></spinner>
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'reportisssue',
  props: ['action'],
  data() {
    return {
      isLoading: false,
      buttonLoaders: {
        send: false
      },
      form: {
        email: '',
        comment: '',
        appVersion: '',
        report: '',
        appInstallHash: '',
        type: 'historyIssue',
        actionID: ''
      }
    };
  },
  methods: {
    loadReportIssueData() {
      this.isLoading = true;
      let settings = this.$store.getters.getSettings;
      if (
        settings &&
        settings.accountSettings &&
        settings.accountSettings.email
      ) {
        this.form.email = settings.accountSettings.email;
      }
      this.form.actionID = this.action.actionID;

      let payload = {
        requiredData: {
          getReportIssueData: this.action.actionID
        }
      };

      this.$store.dispatch('sendAction', payload).then(response => {
        this.form.report = response.data.getReportIssueData.report;
        this.isLoading = false;
      });
    },
    sendReportIssue() {
      this.buttonLoaders.send = true;
      let appInfo = this.$store.getters.getAppInfo;
      this.form.appVersion = appInfo.APP_VERSION;
      this.form.appInstallHash = appInfo.APP_INSTALL_HASH;
      let payload = {};
      payload.requiredData = {
        sendReportIssue: this.form
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.buttonLoaders.send = false;
        this.closeModal();
      });
    },
    closeModal() {
      this.$refs.reportissuemodal.hide();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modals/ReportIssue.vue